// Pure ordering helpers for the series discussion list, extracted out of SeriesDiscussionList.tsx so
// that SeriesPage (statically mounted on every page via ReactMounter) can read/normalize the ordering
// style WITHOUT statically importing SeriesDiscussionList — which pulls @dnd-kit (~255 KB). With this
// split, @dnd-kit only loads through SeriesDiscussionListLazy when the list actually renders.
// See designs/01-now/2026-06-08-frontend-bundle-code-splitting-implementation-plan.md (slice 4).

export type SeriesDiscussionOrderingStyle = "added" | "active";

export function normalizeSeriesDiscussionOrdering(value?: string | null): SeriesDiscussionOrderingStyle {
    return value === "active" ? "active" : "added";
}
